export const getErrorMessage = (error): string => {
  if (!error || !error.response) {
    return error.message;
  }

  const err = error.response;

  if (error.status === 502) {
    return err.statusText;
  }

  if (Array.isArray(err.data.non_field_errors) || Array.isArray(err.data?.errors?.non_field_errors)) {
    return (err.data?.errors?.non_field_errors || err.data.non_field_errors || []).join('\n');
  } else {
    return Object.keys(err.data?.errors || err.data || {})
      .map(key => {
        const value = err.data?.errors?.[key] || err.data[key];
        if (Array.isArray(value)) {
          return value.join(' ');
        }
        if (typeof value === 'object') {
          return JSON.stringify(value);
        }

        return `${value}`;
      })
      .join('\n');
  }
};
